import { ExprCall, ExprFrame } from '@mode-switch/express';
export var Defaults;
(function (Defaults) {
    function make(type, props) {
        props = props || {};
        return {
            frame: props.frame || frame(),
            aggregate: resolveAggregate(type, props.aggregate),
        };
    }
    Defaults.make = make;
    function frame() {
        return ExprFrame.Table.make();
    }
    function aggregate(type) {
        switch (type.name) {
            case "FLOAT":
            case "INTEGER":
            case "DECIMAL": {
                return ExprCall.Name.Sum;
            }
            default: {
                return ExprCall.Name.Count;
            }
        }
    }
    function resolveAggregate(type, callName) {
        if (ExprCall.Name.isKnown(callName !== null && callName !== void 0 ? callName : '')) {
            const agg = callName;
            switch (type.name) {
                case "NULL":
                case "FLOAT":
                case "INTEGER":
                case "DECIMAL": {
                    return agg;
                }
                default: {
                    switch (agg) {
                        case ExprCall.Name.Count:
                        case ExprCall.Name.CountD:
                        case ExprCall.Name.CountDA:
                        case ExprCall.Name.Min:
                        case ExprCall.Name.Max: {
                            return agg;
                        }
                    }
                }
            }
        }
        return aggregate(type);
    }
})(Defaults || (Defaults = {}));
